import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography , Button, 
    Backdrop, CircularProgress} from "@material-ui/core";
import {withRouter, Link} from 'react-router-dom'
import StepperComponent from "./StepperComponent";
import Fab from '@material-ui/core/Fab';
import CamIcon from '@material-ui/icons/VideoCall'
import {Tooltip} from '@material-ui/core'
import ModalVideo from '../../components/base/ModalVideo';
import { SnackbarProvider, useSnackbar } from 'notistack';



const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: "#fff", // Azul acinzentado bem claro
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  }
}));

const FichaCadastroStepper = (props) => {
    const classes = useStyles();
    const [showBackDrop, setShowBackdrop] = useState(false)
    const { nomeEmpresa, chaveIdentificacao, nomeContato, tipoPessoa } = props.match.params;
    return <React.Fragment>
        <div id="div-container-main" className={classes.container}>

         <div style ={{width : '100%',  backgroundColor : '#37474F', padding : '20px', paddingTop : '10px', display: 'flex'}}> 
            <div style={{width : '90%'}}>
            <img src={nomeEmpresa.toUpperCase() == 'CENTERMAQ' ? "http://centermaq.net/img/centermaq.png" : "http://uziprint.com/img/uziprint.png"}  style={{height : '50px'}}/>
            </div>
            <div  style={{width : '10%'}}>
                <ModalVideo 
                    color ='orangered'
                    rotulo
                    urlVideo = ''>
                        <iframe 
                            width="900" 
                            height="500" 
                            src="https://www.youtube.com/embed/rtccDtxwPqM?list=PLiKQeSFs5NZtaqx23PK8_I1Cglf7b2gNo" 
                            title="Como preencher corretamente a Ficha de Cadastro" 
                            frameborder="0" 
                            allow=" autoplay; clipboard-write; encrypted-media; gyroscope; " autoplay >
                                
                        </iframe>
                </ModalVideo>
            </div>
            </div>
        
            
        <StepperComponent setShowBackdrop={(op)=>setShowBackdrop(op) } tipoPessoa ={tipoPessoa}/>
        
    </div>
       
    {showBackDrop ? <div id='div-loader'><CircularProgress color="secondary"/></div> : null }
    </React.Fragment>


}

export default withRouter(FichaCadastroStepper);

